import React__default from 'react';
import { c as TouchLinkContent, C as ChildrenContainer, d as TouchLinkIcon } from './TouchLink.styles-B0xg8y_v.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';

const TouchLinkBody = ({
  children
}) => /*#__PURE__*/React__default.createElement(TouchLinkContent, null, /*#__PURE__*/React__default.createElement(ChildrenContainer, null, children), /*#__PURE__*/React__default.createElement(TouchLinkIcon, {
  type: angleInlineEnd
}));

export { TouchLinkBody as T };
//# sourceMappingURL=TouchLinkBody-yzGPWPL0.js.map
